// extracted by mini-css-extract-plugin
export default {"item":"Item_item__lm7Fw","icon":"Item_icon__eKO4S","title":"Item_title__IATAz","content":"Item_content__HU+GI"};